module.exports = __webpack_public_path__ + "img/auth-person.0fb2e3bd.png";